// IM-XPR-006 (IM-UX-143): barra de abas compartilhada. Uma linha só; quando as abas não cabem, a própria barra rola na
// horizontal (a página nunca) e a aba ativa é trazida para a área visível — sem aba órfã numa segunda linha e sem
// encolher o texto.
import { useEffect, useRef, type ReactNode } from 'react';

export function TabsNav({ label, active, className, children }: { label: string; active: string; className?: string; children: ReactNode }) {
  const ref = useRef<HTMLElement>(null);
  useEffect(() => {
    const nav = ref.current;
    const el = nav?.querySelector<HTMLElement>('a.active, a[aria-current="page"]');
    if (!nav || !el || nav.scrollWidth <= nav.clientWidth) return;
    const left = el.offsetLeft, right = left + el.offsetWidth;
    if (left < nav.scrollLeft || right > nav.scrollLeft + nav.clientWidth) nav.scrollTo?.({ left: Math.max(0, left - 16) });
  }, [active]);
  return <nav ref={ref} className={`tabs${className ? ` ${className}` : ''}`} aria-label={label}>{children}</nav>;
}
